import React from 'react';
import { formatRelative } from '../utils/xFormat';
import { VerifiedBadge, PinIcon } from './XPost';

// Versão compacta do post para o carrossel: cabeçalho do X, 4 linhas de texto,
// a primeira imagem e um rodapé de status. O card inteiro é um botão que abre
// o XPostModal, então o texto vai sem links (link dentro de botão é HTML inválido).

const XPostCard = ({ item, onOpen, hidden = false }) => {
  const post = item.posts[0];
  const cover = post.media?.[0];
  const extra = item.posts.length - 1;

  return (
    <button
      type="button"
      onClick={() => onOpen(item)}
      aria-hidden={hidden || undefined}
      tabIndex={hidden ? -1 : undefined}
      aria-label={hidden ? undefined : `Abrir post de ${formatRelative(post.publishedAt)}`}
      className="flex h-full w-[280px] flex-col rounded-2xl border border-white/10 bg-dark-card/70 p-4 text-left transition-colors hover:border-white/25 hover:bg-dark-card focus:outline-none focus-visible:ring-2 focus-visible:ring-x-blue sm:w-[340px]"
    >
      <div className="flex w-full min-w-0 items-center gap-1 text-[14px] leading-5">
        <img src={item.author.avatar} alt="" className="mr-1 h-8 w-8 shrink-0 rounded-full bg-dark" loading="lazy" />
        {/* como no X: o @ corta antes do nome */}
        <span className="max-w-[55%] shrink-0 truncate font-bold text-light-text">{item.author.name}</span>
        {item.author.verified && <VerifiedBadge className="h-4 w-4 shrink-0 text-x-blue" />}
        <span className="min-w-0 truncate text-secondary-text">@{item.author.handle}</span>
        <span className="text-secondary-text">·</span>
        <span className="shrink-0 text-secondary-text">{formatRelative(post.publishedAt)}</span>
      </div>

      {/* colapsa parágrafos: o clamp conta linha em branco, e o card viraria
          metade vazio */}
      <p className="mt-3 line-clamp-4 whitespace-pre-line break-words text-[15px] leading-5 text-light-text">
        {post.text.replace(/\n{2,}/g, '\n')}
      </p>

      {cover && (
        <div className="mt-auto pt-3">
          <div className="aspect-video overflow-hidden rounded-xl border border-white/10 bg-black">
            <img
              src={cover.src}
              alt=""
              loading="lazy"
              decoding="async"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>
      )}

      <div className={`flex w-full items-center justify-between text-[13px] text-secondary-text ${cover ? 'pt-3' : 'mt-auto pt-3'}`}>
        <span className="flex items-center gap-1.5">
          {item.pinned && (
            <>
              <PinIcon className="h-3.5 w-3.5" />
              Fixado
            </>
          )}
          {!item.pinned && item.isThread && extra > 0 && `Thread · +${extra} posts`}
        </span>
        <span className="text-x-blue">Ler post →</span>
      </div>
    </button>
  );
};

export default XPostCard;
